import React from 'react';
import { NavLink, Link } from 'react-router-dom';

const LINK_TYPES = {
  internal_page: 'internal_page',
  external_url: 'external_url',
};

const getInternalPath = (page = '') => {
  return page.charAt(0) === '/' ? page : `/${page}`;
};

const GenericLink = ({ data, navType = 'basic', className = '', onClick = null }) => {
  const {
    text = '',
    link_type = '',
    external_url = '',
    external_url_target = '_blank',
    page = '',
    extra_classname = false,
  } = data;
  let linkClassName = className || (navType == 'nav' ? 'navigation__link' : 'generic__link');

  if (extra_classname) {
    linkClassName = `${linkClassName} ${extra_classname}`;
  }

  const renderInternalLink = () => {
    if (navType == 'nav') {
      return (
        <NavLink to={getInternalPath(page)} className={linkClassName} aria-label={text} onClick={onClick}>
          {text}
        </NavLink>
      );
    }

    return (
      <Link to={getInternalPath(page)} className={linkClassName} onClick={onClick}>
        {text}
      </Link>
    );
  };

  const renderExternalLink = () => {
    return (
      <a
        href={external_url}
        className={linkClassName}
        aria-label={text}
        target={external_url_target}
        rel="noopener"
        onClick={onClick}
      >
        {text}
      </a>
    );
  };

  return link_type === LINK_TYPES.internal_page ? renderInternalLink() : renderExternalLink();
};

export default GenericLink;
